import type { CostReportClusterSummaryNormalized } from '@cast/shared-cost-data-access';
import { WorkloadReliabilitySummariesResponse } from '@cast/types';

import { buildSloMetricsFromReliability, SloMetric } from './sloHealthMetrics';
import {
  deriveSloFromClusterScore,
  deriveSloFromUnhealthyWorkloads,
  parseClusterScore,
} from './sloDerive';

export type SloColumnData = {
  breachCount: number;
  riskCount: number;
  metrics: SloMetric[];
};

export const buildSloColumnData = ({
  reliability,
  summary,
  oomCount,
}: {
  reliability?: WorkloadReliabilitySummariesResponse;
  summary?: CostReportClusterSummaryNormalized;
  oomCount?: number;
}): SloColumnData => {
  const metrics = buildSloMetricsFromReliability(reliability, oomCount);
  const metricBreaches = metrics.filter(
    (metric) => metric.status === 'breached'
  ).length;

  const unhealthyRaw = reliability?.summary?.unhealthyWorkloads;
  const unhealthyCount =
    unhealthyRaw != null && unhealthyRaw !== '' ? Number(unhealthyRaw) : null;
  const reliabilitySlo = deriveSloFromUnhealthyWorkloads(
    Number.isFinite(unhealthyCount) ? unhealthyCount : null
  );
  const scoreSlo = deriveSloFromClusterScore(
    parseClusterScore(summary?.clusterScore)
  );
  const aggregateSlo = reliabilitySlo ?? scoreSlo;

  let breachCount = metricBreaches;
  let riskCount = 0;

  if (aggregateSlo.state === 'breach') {
    breachCount = Math.max(breachCount, aggregateSlo.count);
  } else if (aggregateSlo.state === 'risk') {
    riskCount = aggregateSlo.count;
  }

  return { breachCount, riskCount, metrics };
};

export const getSloMetricById = (
  metrics: SloMetric[],
  id: string
): SloMetric | undefined => metrics.find((metric) => metric.id === id);
